import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Headline3 from '../Typography/Heading/Headline3';
import Body1 from '../Typography/Body/Body1';
import breakpoints from '../Theme/breakpoints';

const Header = styled(Headline3)`
  text-align: center;
  margin-bottom: 1rem;
`;

const SubHeader = styled(Body1)`
  text-align: center;
  margin-bottom: 1rem;
`;

const Container = styled.div`
  padding: 1rem .5rem 0;

  @media (min-width: ${breakpoints.xssm}) {
    padding: 1.25rem 2.25rem;
  }
`;

const LookbookHeader = ({ title, subtitle }) => (
  <Container>
    <Header tag="h1">{ title }</Header>
    <SubHeader>{ subtitle }</SubHeader>
  </Container>
);

LookbookHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default LookbookHeader;
